import React from 'react';
import {connect} from 'react-redux';
import {useDispatch} from 'react-redux';
import './FuntoneScreen.scss';
import BackButton from '../BackButton/BackButton';
import {ScreensEnum, goBack, setCurrentScreen} from '../../FuntoneSlice';

const FuntoneScreen = ({children, currentScreen, previousScreen, showBackButton = true, backButtonText = 'חזרה', onBackClick}) => {
  const dispatch = useDispatch();
  const shouldShowBackButton = currentScreen !== ScreensEnum.CATALOG;

  const shouldApplyPadding = currentScreen !== ScreensEnum.CATALOG && currentScreen !== ScreensEnum.SONGS_PAGE && currentScreen !== ScreensEnum.ADMIN_PANEL;

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      // Always use goBack reducer for proper navigation stack management
      dispatch(goBack());
    }
  };

  return (
    <div className={`funtone-screen ${shouldApplyPadding ? 'with-padding' : 'no-padding'}`}>
      {shouldShowBackButton && (
        <div className='funtone-screen-header'>
          <BackButton text={backButtonText} onClick={handleBackClick} className='funtone-screen-back-button' />
        </div>
      )}
      {children}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentScreen: state.FuntoneSlice?.currentScreen,
    previousScreen: state.FuntoneSlice?.previousScreen,
  };
};

export default connect(mapStateToProps)(FuntoneScreen);
